export var defualtMeta = [
  {charset:'utf-8'},
  {'http-equiv':'Cache-Control', content:'max-age=0, no-store, no-cache, must-revalidate'},
  {'http-equiv':'Expires', content:'Wed, 11 Jan 1984 05:00:00 GMT1'},
  {'http-equiv':'Pragma', content:'no-cache'},
  {
    vmid: 'viewport',
    name: 'viewport',
    content: 'width=device-width,initial-scale=1.0,minimum-scale=1.0,maximum-scale=1.0,user-scalable=no',
  },
];
